export const SENDING_KEY = 'Sending'

export enum ChatPositionTypes {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
